import React from 'react'
import CookieManagerBtn from '../common/CookieManagerBtn'

import { PrismicLink } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'
import { getLangPath } from '@/utils/getLangFormat'

type DataObject = Record<string, any>
type ItemObject = Record<string, any>

import { useLocale } from '@/context/LocaleContext'

const FooterBottom = React.memo(({ data }: { data: DataObject }) => {
  const locale = useLocale()
  const getTermsPath = (locale: string) => `/${getLangPath(locale)}/terms`
  const getPrivacyPath = (locale: string) => `/${getLangPath(locale)}/privacy`
  const getWebsiteTermsPath = (locale: string) => `/${getLangPath(locale)}/websiteterms`

  return (
    <div className="flex flex-col justify-between pt-[80px] lg:flex-row lg:items-end lg:pt-[120px]">
      <div className="flex gap-2">
        {data.body.map((slice: any) => {
          if (slice.slice_type === 'security_logos') {
            return slice.items.map((item: ItemObject, index: number) => {
              const key = `i-${index}`
              return (
                <div key={key}>
                  <PrismicLink field={item.link} aria-label={item.logo?.alt || 'Security certification'}>
                    <PrismicNextImage field={item.logo} fallbackAlt="" />
                  </PrismicLink>
                </div>
              )
            })
          }
        })}
      </div>

      <div className="my-8 text-sm text-primary-ink-30 lg:my-0">{data.copyright_text}</div>

      <div className="flex gap-6">
        <div className="text-sm text-primary-ink-30">
          <PrismicLink href={locale === 'en-us' ? '/terms' : getTermsPath(locale)}>
            {data.terms_of_service_text}
          </PrismicLink>
        </div>
        <div className="text-sm text-primary-ink-30">
          <PrismicLink href={locale === 'en-us' ? '/privacy' : getPrivacyPath(locale)}>
            {data.privacy_policy_text}
          </PrismicLink>
        </div>
        <div className="text-sm text-primary-ink-30">
          <PrismicLink href={locale === 'en-us' ? '/websiteterms' : getWebsiteTermsPath(locale)}>
            {data.website_terms_text}
          </PrismicLink>
        </div>

        <CookieManagerBtn />
      </div>
    </div>
  )
})

FooterBottom.displayName = 'FooterBottom'
export default FooterBottom
